import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './app/store';
import Root from './commons/components/Root';
import './index.css';
import Dashboard from './commons/components/Dashboard';
import OrderDetails from './features/campaigns/OrderDetails';
import ActiveCampaigns from './commons/components/ActiveCampaigns';
import CampaignsHistory from './commons/components/CampaingsHistory';
import UsersManagement from './commons/components/UsersManagement';
import Login from './features/login/Login';
import Reset from './features/login/Reset';
import SetPassword from './features/auth/SetPassword';
import UserForm from './features/users/UserForm';
import GestioneTestate from './commons/components/GestioneTestate';
import FormTestate from './features/testate/FormTestate';

const container = document.getElementById('root')!;
const root = createRoot(container);

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    children: [
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/user/reset',
        element: <Reset />,
      },
      {
        path: '/user/reset-password',
        element: <SetPassword />,
      },
      {
        path: '/set-password',
        element: <SetPassword />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'campagne',
        element: <ActiveCampaigns />,
      },
      {
        path: 'storico',
        element: <CampaignsHistory />,
      },
      {
        path: '/admin/testate/',
        element: <GestioneTestate />,
        children: [
          {
            path: 'nuova-testata',
            element: <FormTestate />,
          },
        ],
      },
      {
        path: '/admin/utenze/',
        element: <UsersManagement />,
        children: [
          {
            path: 'modifica-utente/:userId',
            element: <UserForm />,
          },
          {
            path: 'nuovo-utente',
            element: <UserForm />,
          },
        ],
      },
      {
        path: 'orderpage/:orderId',
        element: <OrderDetails />,
      },
    ],
  },
]);

root.render(
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>,
);
